import { v4 as uuidv4 } from 'uuid';
import { API_REQUEST_TIMEOUT_DEFAULT_SEC } from './constants';
import { APP_ENVIRONMENT, AUTH_CODE_METHOD, AUTH_RESPONSE_TYPE, AUTH_SCOPE, AUTH_TOKEN_URL, AUTHORIZATION_CODE, GUEST_GRANT_TYPE, GUEST_SCOPE, GUEST_TOKEN_URL, LOGIN_DOMAIN, LOGIN_STATE, LOGOUT_URL, REFRESH_GRANT_TYPE, REFRESH_TOKEN_URL, TENANT_OS_ENDPOINT_BASE_URL, TENANT_IMAGE_BASE_URL, API_REQUEST_TIMEOUT_SEC, TOKEN_INTERVAL_TIMEOUT_SECS, REFRESH_TOKEN_EXPIRING_IN_SECS, CHECK_ACCESS_TOKEN_INTERVAL_MILLIS, REFRESH_TOKEN_MAX_RETRY_COUNT, REGISTER_URL, AKAMAI_RESTRICTED_RESOURCE_PATHS, GOOGLE_BASE_URL_PROXY, } from './config/config.constants';
import AuthConstants from './auth/models/AuthConstants';
import { config, configAsNumber } from './config/config.utils';
const { INTERVAL_TIMEOUT_SECS, REFRESH_TOKEN_API_MAX_RETRY_COUNT, REFRESH_TOKEN_EXPIRING_IN_DEFAULT_SECS, CHECK_ACCESS_TOKEN_INTERVAL_DEFAULT_MILLIS, } = AuthConstants;
class App {
    constructor() {
        this._envVars = {
            xCorrelationSessionId: uuidv4(),
        };
    }
    static get instance() {
        /* istanbul ignore next */
        if (!App._instance) {
            App._instance = new App();
        }
        return App._instance;
    }
    set appApiBaseUrl(value) {
        this._envVars = {
            ...this.envVars,
            appApiBaseUrl: value,
        };
    }
    get appApiBaseUrl() {
        return this._envVars?.appApiBaseUrl || '';
    }
    set tenantCode(value) {
        this._envVars = {
            ...this.envVars,
            tenantCode: value,
        };
    }
    get tenantCode() {
        return this._envVars?.tenantCode || 'au';
    }
    set channel(value) {
        this._envVars = {
            ...this.envVars,
            channel: value,
        };
    }
    initialize() {
        this._envVars = {
            ...this.envVars,
            authParams: {
                guestScope: config(GUEST_SCOPE),
                memberScope: config(AUTH_SCOPE),
                guestGrantType: config(GUEST_GRANT_TYPE),
                memberGrantType: config(AUTHORIZATION_CODE),
                refreshGrantType: config(REFRESH_GRANT_TYPE),
                tokenIntervalTimeoutSecs: configAsNumber(TOKEN_INTERVAL_TIMEOUT_SECS, INTERVAL_TIMEOUT_SECS) * 1000,
                refreshTokenMaxRetryCount: configAsNumber(REFRESH_TOKEN_MAX_RETRY_COUNT, REFRESH_TOKEN_API_MAX_RETRY_COUNT),
                refreshTokenExpiringInSecs: configAsNumber(REFRESH_TOKEN_EXPIRING_IN_SECS, REFRESH_TOKEN_EXPIRING_IN_DEFAULT_SECS),
                checkAccessTokenIntervalMillis: configAsNumber(CHECK_ACCESS_TOKEN_INTERVAL_MILLIS, CHECK_ACCESS_TOKEN_INTERVAL_DEFAULT_MILLIS),
                authCodeMethod: config(AUTH_CODE_METHOD),
                loginState: config(LOGIN_STATE),
                authResponseType: config(AUTH_RESPONSE_TYPE),
                signInUrl: config(LOGIN_DOMAIN),
                signUpUrl: config(REGISTER_URL),
                appEnvironment: config(APP_ENVIRONMENT),
            },
            oloApiBaseUrl: config(TENANT_OS_ENDPOINT_BASE_URL),
            oloImageBaseUrl: config(TENANT_IMAGE_BASE_URL),
            googleBaseUrl: config(GOOGLE_BASE_URL_PROXY),
            authBaseUrl: config(AUTH_TOKEN_URL),
            refreshBaseUrl: config(REFRESH_TOKEN_URL),
            guestBaseUrl: config(GUEST_TOKEN_URL),
            logoutBaseUrl: config(LOGOUT_URL),
            requestTimeoutSecs: configAsNumber(API_REQUEST_TIMEOUT_SEC, API_REQUEST_TIMEOUT_DEFAULT_SEC) * 1000,
            akamaiRestrictedResourcePaths: config(AKAMAI_RESTRICTED_RESOURCE_PATHS)?.split(','),
        };
    }
    get envVars() {
        return this._envVars;
    }
    set envVars(value) {
        this._envVars = {
            ...this.envVars,
            ...value,
            authParams: {
                ...this.envVars.authParams,
                ...value.authParams,
            },
        };
    }
    set language(value) {
        this._envVars = {
            ...this.envVars,
            language: value,
        };
    }
}
const instance = App.instance;
export default instance;
